import { filter } from 'rxjs/operators';
import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { CovoiturageService } from 'src/app/api/covoiturage.service';
import { MatTableDataSource } from '@angular/material/table';
import { DateAdapter } from '@angular/material/core';
import { DetailCovoiturageComponent } from './detail-covoiturage/detail-covoiturage.component';
import { MatDialog } from '@angular/material/dialog';
import { startWith, map } from 'rxjs/operators';
import { FormControl } from '@angular/forms';
import { Observable } from 'rxjs';
import { Location } from '@angular/common';

@Component({
  selector: 'app-covoiturage',
  templateUrl: './covoiturage.component.html',
  styleUrls: ['./covoiturage.component.scss']
})
export class CovoiturageComponent implements OnInit {

  constructor(private location: Location, private dialog: MatDialog, private covoiturageService : CovoiturageService, public snackBar: MatSnackBar, private dateAdapter: DateAdapter<Date>,) 
  { 
    this.dateAdapter.setLocale('fr');
    this.getStation();
    this.getSite();
  }

  @ViewChild('filterStation') inputStation: ElementRef

    //barre de recherche 
    stateCtrl = new FormControl();
    filteredStates: Observable<any[]>;
    isAutopartage: boolean = true;
    isRecharge: boolean = true;
    listStation: any[];
    filtredStation: any[] = [];
    selectedStation: any

    emplacement: string = '';

  reservations
  destination
  nbplace
  currentUser
  isShareTrajet = false
  isUpdateTrajet = false

  covoiturages: any[] = [];
  page: number = 1;
  pageSize: number = 15;
  total: number;
  firstname = '';
  lastname = '';
  phonenumber = '';
  IsWait: boolean = true;
  IsWaitbar: boolean = false;

  


  displayedColumns: string[] = ['debut', 'emplacement', 'destination', 'place', 'covoiturer' ];
  dataSource = new MatTableDataSource<any>(this.covoiturages);


  ngOnInit(): void {
   this.initial()
  }


  initial(){
    this.subscribeToCovoiturages()

  
    let tokenString = localStorage.getItem('token_clem_mobi')

    console.log(tokenString == null)
    let token = JSON.parse(tokenString)

    if(tokenString){
      this.subscribeToReservations()
      this.subscribeToCurrentUser()
    }
  
  }



  subscribeToReservations() {

    // this.startDate = moment(this.startDate).subtract(1, 'day')

    this.covoiturageService.getBook().subscribe(
      (res) => {
        console.log(res)
        this.reservations = res.data.filter(x => x.type === 1)

        this.reservations.map(result => {

              console.log('picture_id')
              console.log(result.id)

              this.covoiturageService.getCovoiturageById(result.id).subscribe(

                value => {
                  console.log("value post");
                  console.log(value);
                  result.covoiturage.destination = value?.data?.destination
                  result.covoiturage.nbplace = value?.data?.nbplace
                  // return 'data:' + value?.mimetype + ';base64,' + value?.source
                  // this.openSnackBarDone('Tour du véhicule envoyé avec succès')

                },
                error => { console.log(error); this.openSnackBarError(error.error.message) }
              );

        })
      },
      err => {
        console.log(err)
        this.openSnackBarError(err.message)
      });

  }




  subscribeToCurrentUser() {

    this.covoiturageService.getCurrentUser().subscribe(
      (res) => {
        console.log(res)
        this.currentUser = res.data
      },
      err => {
        console.log(err)
        this.openSnackBarError(err.message)
      });

  }


  subscribeToGetCovoiturageById(id) {

    this.covoiturageService.getCovoiturageById(id).subscribe(
      (res) => {
        console.log(res)
        return res.data
      },
      err => {
        console.log(err)
        this.openSnackBarError(err.message)
      });

  }


  partageTrajet(item){
    console.log("==================avant===============")
    console.log(item)
    this.isShareTrajet = true
    item.covoiturage.share = true
    console.log("================partage====================")
    console.log(item)
  }

  updateTrajetCovoiturage(item){
    console.log("==================avant===============")
    console.log(item)
    this.isUpdateTrajet = true
    item.covoiturage.update = true
    console.log("==================update===============")
    console.log(item)
  }



  createCovoiturage(item){

    console.log(item)

    if(!item.covoiturage.destination){
      this.openSnackBarError("Pour partager votre trajet il faut renseigner votre destination")
      return
    }
    if(!item.covoiturage.nbplace){
      this.openSnackBarError("Pour partager votre trajet il faut renseigner le nombre de places disponnibles")
      return
    }
   
    let body = {

      id: item.id,
      car_name: item.car_name,
      startdate: item.startdate,
      enddate: item.enddate,
      price: item.price,
      station_id: item.station_id,
      station_name: item.station_name,
      status: item.status,
      type: item.type,
      nbplace: item.covoiturage.nbplace,
      destination: item.covoiturage.destination,
      station: item.station,
      created_by: {
            id: this.currentUser.id,
            username: this.currentUser.name,
            firstname: this.currentUser.firstname,
            lastname: this.currentUser.lastname,
            community_id: this.currentUser.community.id,
            community_name: this.currentUser.community.name,
            email: this.currentUser.email,
            phonenumber: this.currentUser.phonenumber,
        }
    }

    console.log( body)
   

    this.covoiturageService.sendCovoiturage(body).subscribe(
      data => {

        // this.loading = false;
        console.log(data)
        this.openSnackBarDone('Compte créé avec succès')
        this.initial()
        this.isShareTrajet = false

      },
      err => {
        // this.loading = false;
        console.log(err)
        this.openSnackBarError(err)
      });

  

  }


  updateCovoiturage(item){

    console.log(item)

    if(item.covoiturage.destination === ""){
      this.openSnackBarError("Pour partager votre trajet il faut renseigner votre destination")
      return
    }

    if(item.covoiturage.nbplace === null){
      this.openSnackBarError("Pour partager votre trajet il faut renseigner le nombre de places disponnibles")
      return
    }

   
    let body = {
      nbplace: item.covoiturage.nbplace,
      destination: item.covoiturage.destination,
    }

    console.log( body)
   

    this.covoiturageService.updateCovoiturage(item.id, body).subscribe(
      data => {
        console.log(data)
        this.openSnackBarDone('Covoiturage modifié avec succès')
        this.initial()
        this.isUpdateTrajet = false
      },
      err => {
        console.log(err)
        this.openSnackBarError(err)
      });

  

  }





  // sbscribe covoiturage
  subscribeToCovoiturages() {
    this.covoiturageService.getListeCovoiturages(this.page, this.pageSize, this.emplacement).subscribe((res) => {
      this.IsWait = false;
      this.covoiturages = res.data
      this.page = res.page
      this.total = res.total
    })
  }

  filterCovoiturages() {
      this.covoiturageService.getListeCovoiturages(this.page, this.pageSize, this.selectedStation.id).subscribe((res) => {
        this.IsWait = false;
        this.covoiturages = res.data
        this.page = res.page
        this.total = res.total
      })
    }

  // page covoiturage
  handlePage($event) {
    this.IsWaitbar = true
    this.covoiturageService.getListeCovoiturages($event.pageIndex + 1 , $event.pageSize, this.emplacement,).subscribe((res) => {
      this.IsWait = false;
      this.covoiturages = res.data
      this.page = res.page
      this.total = res.total
    })
  }

  reset() {


    this.inputStation.nativeElement.value = '';
 
    console.log(this.listStation)
    this.filterListStation(this.listStation)
  

    if (this.selectedStation) {
      this.selectedStation = undefined
    }
    this.subscribeToCovoiturages()
 

  }



  getDateFormat(str : string){
    var newString = str.replace('-','/').replace('-', '/').replace('T',' ').replace(':00Z','');
   return  newString
  }


  getStation() {
    this.covoiturageService.getListeStationsGuest().subscribe(
      res => {
        this.listStation = res.data
        this.filterListStation(res.data)
      },
      err => {
        this.openSnackBarError(err.error.message)
      });
  }

  

    // detail 
    detailCovoiturage(element): void {

      console.log("==================detttail===============")
      console.log(element)

      if(this.currentUser){
          element.isConnected = true
      }else{
          element.isConnected = false
      }

      this.dialog.open(DetailCovoiturageComponent, {
        width: '750px',
        data: element
      });
    }




  // autocomplete station 
  filterListStation(filtredStation) {
    console.log(filtredStation)

    this.filteredStates = this.stateCtrl.valueChanges
      .pipe(
        startWith(''),
        map(state => state ? this._filterStates(state, filtredStation) : filtredStation.slice())
      );
  }

  private _filterStates(value: string, filtredStation: any): any[] {
    const filterValue = value.toLowerCase();
    return filtredStation.filter(state => state.name.toLowerCase().includes(filterValue));
  }

  onStationChanged(event) {
    this.listStation.forEach(station => {
      if (station.name == event.option.value) {
        this.selectedStation = station
        return;
      }
    });
  }



  goBack(): void {
  this.location.back();
  }


siteType = 'default';

getSite() {
  const host = location.host;

  switch (host) {

    case 'mam.clem.mobi':
    case 'www.mam.clem.mobi':
      this.siteType = 'mam';
      break;

    case 'remiautopartage.clem.mobi':
    case 'www.remiautopartage.clem.mobi':
    // case 'localhost:4200':
    // case `devghiles.clem.mobi` : 
      this.siteType = 'remi';
      break;

    default:
      this.siteType = 'default';
  }
}




  openSnackBarDone(message: string) {
    this.snackBar.open(message, "X", {
      panelClass: ['sucess-snackbar'],
      duration: 20000,
    });
  }



  openSnackBarError(message: string) {
    this.snackBar.open(message, "X", {
      panelClass: ['error-snackbar'],
      duration: 2000,
    });
  }



}
